export default __webpack_public_path__ + "static/media/illustrate-document-pdf.f35b84d8.svg";